import { Asset as e } from "../assets/Asset.js";
import { REFlag24Artwork as t } from "../assets/artwork/REFlag24Artwork.js";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/flags/GPFlag.tsx
var r = {
	12: {
		Artwork: t,
		width: 24,
		height: 24
	},
	16: {
		Artwork: t,
		width: 24,
		height: 24
	},
	20: {
		Artwork: t,
		width: 24,
		height: 24
	},
	24: {
		Artwork: t,
		width: 24,
		height: 24
	}
}, i = ({ size: t = 16, ...i }) => /* @__PURE__ */ n(e, {
	source: r[t],
	frame: "circle",
	...i
});
//#endregion
export { i as GPFlag };
